import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getTokenFromStorage,
  validateCaresenseToken,
} from '../AnyfitMall/common';
import { generateCaresenseAuthUrl, CARESENSE_CONFIG } from './config';
import CaresenseLayout from 'components/Caresense/CaresenseLayout';
import CaresenseLoading from 'components/Caresense/CaresenseLoading';
import { navigateToCaresenseError } from './caresenseErrors';

/**
 * 케어센스 로그아웃 콜백 페이지
 * 케어센스 로그아웃 완료 후 리다이렉트되어 OAuth 인증을 시작함
 * 전체 플로우: Login(0-15%) → LogoutCallback(15-30%) → OAuth → Callback(30-100%)
 */
const CaresenseLogoutCallback = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(15);

  useEffect(() => {
    const initOAuth = async () => {
      const isDev = ['local', 'dev'].includes(process.env.REACT_APP_ENV);

      try {
        setProgress(20);

        // 1. localStorage에서 토큰 확인
        const token = getTokenFromStorage();

        if (!token) {
          console.error('[Caresense] 토큰 없음');
          navigateToCaresenseError(navigate);
          return;
        }

        setProgress(25);

        // 2. 토큰 유효성 검증
        const validationResult = await validateCaresenseToken(token);

        if (!validationResult.result) {
          console.error('[Caresense] 토큰 검증 실패');
          navigateToCaresenseError(navigate);
          return;
        }

        setProgress(30);

        // 3. OAuth URL 생성 및 리다이렉트
        const useOIDC = CARESENSE_CONFIG.useOpenIdConnect;
        const authUrl = generateCaresenseAuthUrl(useOIDC);

        if (isDev) {
          console.log('[Caresense] 로그아웃 콜백 - OAuth 시작:', {
            mode: useOIDC ? 'OIDC' : 'OAuth',
            authUrl,
          });
        }

        window.location.href = authUrl;
      } catch (error) {
        console.error('[Caresense] OAuth 초기화 오류:', error);
        navigateToCaresenseError(navigate);
      }
    };

    initOAuth();
  }, [navigate]);

  return (
    <CaresenseLayout>
      <CaresenseLoading progress={progress} title="케어센스 연동 준비 중" />
    </CaresenseLayout>
  );
};

export default CaresenseLogoutCallback;
